var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 29,
    viewBox: "0 0 38 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0219115 20.2477C0.24462 22.3264 3.91509 25.0823 6.96671 26.597C10.3596 28.281 19.542 30.0799 16.5154 28.1967C2.44973 19.445 27.2858 22.0267 35.4991 23.0631C36.8369 23.2319 38 21.8253 38 20.0246C38 18.3542 36.9895 17 35.743 17L2.2396 17C0.902893 17 -0.16806 18.4745 0.0219115 20.2477Z",
    fill: "#008DD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.05 2.40305C24.2182 3.91775 26.8262 6.67361 26.9844 8.75231C27.1194 10.5255 26.3585 12 25.4087 12H1.60366C0.717985 12 7.64885e-10 10.6458 7.64885e-10 8.97537C7.64885e-10 7.17473 0.826427 5.76814 1.77693 5.93694C7.61274 6.97329 25.2594 9.55499 15.2654 0.803298C13.1149 -1.07988 19.6393 0.718972 22.05 2.40305Z",
    fill: "#008DD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.8269330d39423c72b6d73ef07d12844c.svg";
export { ForwardRef as ReactComponent };